export default "__VITE_ASSET__DMgWrsr1__";